// extracted by mini-css-extract-plugin
export default {"component":"uOWL_Q","preloader":"d5ogIp"};